/**
 * @flow
 */

import {
  ON_YOUR_TICKET_SUCCESS
} from './actions';

const initialState = {
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_YOUR_TICKET_SUCCESS:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/your-ticket/reducer.js